module.exports = __webpack_public_path__ + "media/images/common/icon/icon-search-b-351950a8c4d35e6f4f4350ed0f3d86b7.svg";